import { SnLonLat } from '@lib/geo/helpers';

import { EsriTheme } from '../enum/esri-theme.enum';

export interface IEsriMapEvents {
  click: SnLonLat;
  dblclick: SnLonLat;
  rightclick: SnLonLat;
  dragstart: undefined;
  drag: undefined;
  dragend: undefined;
  idle: undefined;
  centerChange: undefined;
  boundsChange: undefined;
  zoomChange: number;
  styleChange: EsriTheme;
  tilesLoaded: undefined;
  tilesLoadError: { timeoutMs: number };
  'overlay:add': any;
  'overlay:remove': any;
}
